import {
  ChangeDetectorRef,
  Component,
  HostListener,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { EmployeeService } from '../services/employee.service';
import { AuthService } from '../auth/services/auth.service';
import { OverlayPanel } from 'primeng/overlaypanel';
import { formatDate } from '@angular/common';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
})
export class LayoutComponent {
  permissions: string[] = [];
  currentDate: string = '';
  userData: any = null;
  fullname: string = '';
  employeeData: any = null;
  // endContract: Date | null = null;
  stateContractId: number = 0;
  statePaymentId: number = 0;
  notificationCount: number = 0;
  notifications: any[] = [];
  isMenuOpen: boolean = false;
  isMenuCollapsed: boolean = false;
  isMobile: boolean = window.innerWidth <= 768;
  showLogoutButton: boolean = false;
  isLoading: boolean = false;

  @ViewChild('op') op!: OverlayPanel;

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.isMobile = window.innerWidth <= 768;
  }

  @HostListener('document:click', ['$event'])
  onClick(event: MouseEvent) {
    const target = event.target as HTMLElement;

    if (this.isMobile && this.isMenuOpen) {
      const isClickInsideMenu = target.closest('.sidebar nav') !== null;
      const isClickOnToggle = target.closest('.menu-toggle') !== null;
      const isClickOnNavOption =
        target.closest('.sidebar nav ul li a') !== null;

      if ((!isClickInsideMenu && !isClickOnToggle) || isClickOnNavOption) {
        this.closeMenu();
      }
    }

    if (this.isMobile && this.showLogoutButton) {
      const isClickOnProfileImage =
        target.closest('.profile-section img') !== null;
      const isClickOnLogoutButton =
        target.closest('.logout-button-mobile') !== null;

      if (!isClickOnProfileImage && !isClickOnLogoutButton) {
        this.showLogoutButton = false;
      }
    }
  }

  menuOptions = [
    {
      label: 'Inicio',
      icon: 'pi pi-home',
      route: '/dashboard/home',
      permission: 'VIEW_INICIO_COLLABORATOR',
    },
    {
      label: 'Vacaciones',
      icon: 'pi pi-sun',
      route: '/dashboard/vacation',
      permission: 'VIEW_VACACIONES_COLLABORATOR',
    },
    {
      label: 'Boletas',
      icon: 'pi pi-file',
      route: '/dashboard/payment-slips',
      permission: 'VIEW_BOLETAS_COLLABORATOR',
    },
    // {
    //   label: 'Ticket y Vales',
    //   icon: 'pi pi-ticket',
    //   route: '/dashboard/ticket',
    //   permission: 'VIEW_VACACIONES_COLLABORATOR',
    // },
    {
      label: 'Solicitudes',
      icon: 'pi pi-clock',
      route: '/dashboard/solicitude',
      permission: 'VIEW_BOLETAS_COLLABORATOR',
    },
    {
      label: 'Mis Contratos',
      icon: 'pi pi-folder-open',
      route: '/dashboard/contracts',
      permission: 'VIEW_BOLETAS_COLLABORATOR',
    },
    // {
    //   label: 'Adelanto de sueldo',
    //   icon: 'pi pi-wallet',
    //   route: '/dashboard/salary-advance',
    //   permission: 'VIEW_BOLETAS_COLLABORATOR',
    // },
  ];

  filteredMenuOptions: any[] = [];

  constructor(
    private router: Router,
    private authService: AuthService,
    private employeeService: EmployeeService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.authService.user$.subscribe((user) => {
      this.userData = user;
      console.log('Usuario actualizado: ', this.userData);
      if (this.userData) {
        this.getName();
      } else {
        console.log('employeeId no está definido');
      }
    });

    this.loadPermissions();
    this.filterMenuOptions();

    const date = new Date();

    // Array con los meses en español
    const months = [
      'Enero',
      'Febrero',
      'Marzo',
      'Abril',
      'Mayo',
      'Junio',
      'Julio',
      'Agosto',
      'Septiembre',
      'Octubre',
      'Noviembre',
      'Diciembre',
    ];

    // Construir la fecha en el formato deseado
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();

    // Formato: "Diciembre 18 del 2024"
    this.currentDate = `${month} ${day} del ${year}`;
  }

  loadPermissions(): void {
    const storedAccess = localStorage.getItem('access');
    if (storedAccess) {
      const parsedAccess = JSON.parse(storedAccess);
      this.permissions = parsedAccess.permissions || [];
    }
  }

  filterMenuOptions(): void {
    this.filteredMenuOptions = this.menuOptions.filter((option) =>
      this.permissions.includes(option.permission)
    );
  }

  getName(): void {
    if (!this.userData) {
      console.error('Error: userData no está definido');
      return;
    }
    this.isLoading = true;

    // console.log('Llamando a la API con userData:', this.userData);
    this.employeeService.getEmployeeById(this.userData.employeeId).subscribe(
      (employee) => {
        if (employee) {
          this.fullname =
            employee.names.split(' ')[0] +
            ' ' +
            employee.lastNames.split(' ')[0];
            this.employeeData = employee;

          if (employee.stateLastContractId) {
            this.stateContractId = employee.stateLastContractId;
          }

          if (employee.stateLastPaymentSlipId) {
            this.statePaymentId = employee.stateLastPaymentSlipId;
          }
          this.isLoading = false;
          this.updateNotifications();
        } else {
          console.log('No se encontró el empleado');
          this.isLoading = false;
        }
      },
      (error) => {
        console.error('Error al obtener el empleado:', error);
        this.isLoading = false;
      }
    );
  }

  toggleNotification(event: Event, button: HTMLElement) {
    this.op.toggle(event, button);

    setTimeout(() => {
      const panelElement = document.querySelector(
        '.p-overlaypanel'
      ) as HTMLElement;
      const button = document.querySelector('.pi-bell')?.parentElement;

      if (panelElement && button) {
        const navbar = document.querySelector('.navbar') as HTMLElement;
        const buttonRect = button.getBoundingClientRect();

        const navbarRect = navbar?.getBoundingClientRect();
        let offsetLeft = navbarRect
          ? buttonRect.left - navbarRect.left
          : buttonRect.left;

        if (this.isMenuCollapsed) {
          offsetLeft -= 180; // Sumar el ancho del sidebar plegado (70px)
        }

        panelElement.style.left = `${offsetLeft - 15}px`;
        panelElement.style.top = `${buttonRect.bottom - 5}px`;
        panelElement.style.transform = `translateX(-50%)`;
      }
    }, 0);
  }

  toggleMenu(): void {
    if (this.isMobile) {
      this.isMenuOpen = !this.isMenuOpen;
    } else {
      this.isMenuCollapsed = !this.isMenuCollapsed;
    }
  }

  toggleLogoutButton(): void {
    this.showLogoutButton = !this.showLogoutButton;
  }

  closeMenu(): void {
    this.isMenuOpen = false;
  }

  logout(): void {
    localStorage.clear();
    this.router.navigate(['/auth/login']);
  }

  updateNotifications(): void {
    this.notifications = [];

    // Para contrato enviado
    if (this.stateContractId === 2 || this.stateContractId === 5) {
      this.notifications.push({
        title: 'Firmar contrato',
        message: `Tienes un contrato pendiente por firmar.`,
      });
    }

    // if (this.stateContractId === 3) {
    //   this.notifications.push({
    //     title: 'Contrato aprobado',
    //     message: `El contrato ha sido aprobado. Felicidades!`,
    //   });
    // }

    // if (this.stateContractId === 7) {
    //   this.notifications.push({
    //     title: 'Contrato rechazado',
    //     message: `El contrato no ha sido aprobado, comunícate con el área de RR.HH.`,
    //   });
    // }

    // Para boleta enviado
    if (this.statePaymentId === 2) {
      this.notifications.push({
        title: 'Firmar boleta',
        message: `Tienes una boleta pendiente por firmar.`,
      });
    }

    this.notificationCount = this.notifications.length;
  }
}
